import { RE_ENTER_PROPERTY_ID_PREFIX } from 'reEnter';
import {
  FormPageAuthInputData,
  FormPageAuthProperties,
  FormPageInputData,
  FormPageProperties,
} from 'shared';
import { convertValue } from './convertValue';

type ConvertFormPageInputDataForValidationReturnType = {
  [propertyId: string]: any;
};

export const convertFormPageInputDataForValidation = (
  properties: FormPageProperties | FormPageAuthProperties,
  values: FormPageInputData | FormPageAuthInputData,
): ConvertFormPageInputDataForValidationReturnType => {
  if (!properties) {
    return values;
  }
  return Object.entries(values).reduce((acc, [propertyId, value]) => {
    const isReEnter = propertyId.startsWith(RE_ENTER_PROPERTY_ID_PREFIX);
    const _propertyId =
      (!isReEnter && propertyId) ||
      propertyId.replace(RE_ENTER_PROPERTY_ID_PREFIX, '');
    const property = properties[_propertyId];
    return {
      ...acc,
      [propertyId]: convertValue(property, value),
    };
  }, {});
};
